import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SetToggleTheme } from './contexts/SetToggleThemeContext';
import { CheckDevice } from './contexts/DeviceContext';

ReactDOM.render(
  <React.StrictMode>
    <SetToggleTheme>
      <CheckDevice>
        <App />
      </CheckDevice>
    </SetToggleTheme>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
